import { createAsyncThunk } from "@reduxjs/toolkit";
import { WidgetType } from "@/services/cloudchipr.api";
import { getCostAnomaliesWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/cost-anomalies/data-get/getCostAnomaliesWidgetDataByWidgetIdThunk";
import { getBillingExplorerWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/getBillingExplorerWidgetDataByWidgetIdThunk";
import { getBillingSummaryWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/billing-summary/data-get/getBillingSummaryWidgetDataByWidgetIdThunk";
import { getCommitmentUtilizationWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/commitment-utilization/getCommitmentUtilizationWidgetDataByWidgetIdThunk";
import { getTextWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/text-widget/getTextWidgetDataByWidgetIdThunk";
import { getCoverageWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/coverage-widget/getCoverageWidgetDataByWidgetIdThunk";
import { getNormalizedCostWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/getNormalizedCostWidgetDataByWidgetIdThunk";

export const getWidgetDataByTypeAndIdThunk = createAsyncThunk(
  "dashboards/getWidgetDataByTypeAndId",
  async (
    { widgetId, type }: { widgetId: string; type: WidgetType },
    { dispatch },
  ) => {
    if (type === "cost_breakdown") {
      dispatch(
        getBillingExplorerWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "cost_and_usage_summary") {
      dispatch(
        getBillingSummaryWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "largest_cost_changes") {
      dispatch(
        getCostAnomaliesWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "commitments_utilization") {
      dispatch(
        getCommitmentUtilizationWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "text") {
      dispatch(
        getTextWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "coverage") {
      dispatch(
        getCoverageWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }

    if (type === "normalized_cost") {
      dispatch(
        getNormalizedCostWidgetDataByWidgetIdThunk({
          widgetId,
          forceRefetch: true,
        }),
      );
    }
  },
);
